import React, { useState, useEffect, Fragment, useRef } from "react";
import groupService from "../../../Group/services";
import service from "../service";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { PageHeader } from "../../../../Common";
import Joi from "@hapi/joi";
import { validateProperty, validate } from "../../../Common";
import FormHelperText from "@material-ui/core/FormHelperText";
import "react-datepicker/dist/react-datepicker.css";
import { SummeryReportSchema } from "../summeryReportSchema";
import { TableContentWithoutEdit } from "../../../Common/Table/tableContent";
import $, { error } from "jquery";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../Common/services";
import tokenService from "../../../../Common/tokenDecoder";
import "../../../Common/Table/table.css";
import Box from "@material-ui/core/Box";
import MessageModal from "../../../../UI/Modal/MessageModal";

import TextField from "@material-ui/core/TextField";

import MaterialTable from "material-table";
const screenCode = "INTEGRATIONRETRYOPTION";

export function IntegrationRetryOption(props) {
  const componentRef = useRef();

  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);

  const [searchData, setsearchData] = useState({
    groupID: "0",
    operationEntityID: "0",
    tagNumber: "0",
    failureCount: "3",
    vendorTypeID: "2",
    date: "",
    productCollectionDetailsID: "0",
    requestStream: "",
    leafCollectionStatusID: "0",
  });

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });

  const [isViewTable, setIsViewTable] = useState(true);

  const pdfRef = React.createRef();
  const [errors, setErrors] = useState({});

  const schema = Joi.object(SummeryReportSchema).options({
    allowUnknown: true,
  });
  const [reportData, setReportData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  useEffect(() => {
    createDataTable();
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    trackPromise(getOperationEntities());
  }, [searchData.groupID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWINTEGRATIONRETRYOPTION"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );
    setPermissions({
      ...permissionList,

      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();
    setsearchData({
      ...searchData,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropDown());
  }

  function createDataTable() {
    $("#routeCollectionSummaryReport").DataTable();
  }

  async function getGroupsForDropDown() {
    const groupsList = await groupService.getGroupsForDropdown();
    setGroups(groupsList);
  }

  async function getOperationEntities() {
    const operationEntityList =
      await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
    setOperationEntity(operationEntityList);
  }

  function handleChange(e) {
    e.preventDefault();

    const target = e.target;
    const value = target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(target, SummeryReportSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setsearchData({
      ...searchData,
      [e.target.name]: value,
    });

    setErrors(error);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    const errorMessages = validate(schema, searchData);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    let data = {
      operationEntityID: parseInt(searchData.operationEntityID),
      failureCount: parseInt(searchData.failureCount),
      vendorTypeID: parseInt(searchData.vendorTypeID),
      cardReadTime: searchData.date,
    };
    const loftData = await service.getReportData(data);
    if (loftData != null || loftData != undefined) {
      setReportData(loftData);

      setIsViewTable(false);
    } else {
      setIsViewTable(true);
    }
  }
  async function retryOption(rowData) {
    let data = {
      productCollectionDetailsID: rowData.productCollectionDetailsID,
      requestStream: rowData.requestStream,
      leafCollectionStatusID: rowData.leafCollectionStatusID,
    };
    const retryData = await service.retryOptionData(data);
    if (retryData != null) {
      if (retryData.statusCode != null || retryData != undefined) {
        if (retryData.statusCode == "True") {
          setReportData(retryData);
          setMessageModel({
            ...messageModel,
            hidden: false,
            type: "Success",
            disciption: retryData.message,
          });
          setTimeout(() => {
            modalDismissHandler();
          }, 1500);
        } else {
          setMessageModel({
            ...messageModel,
            hidden: false,
            type: "Error",
            disciption: retryData.message,
          });
          setTimeout(() => {
            modalDismissHandler();
          }, 1500);
        }
      }
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: "Error",
        disciption: "Error code",
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 1500);
    }
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="card">
          <div ref={pdfRef} className="card-body">
            <div className="row">
              <PageHeader
                title="Integration Option Report"
                isButtonEnable={false}
              />
            </div>
            <form>
              <div className="form-group row">
                <div className="col-md pb-1">
                  <InputLabel shrink id="groupID">
                    Group *
                  </InputLabel>
                  <Select
                    fullWidth
                    id="groupID"
                    disabled={!permissionList.isGroupFilterEnabled}
                    name="groupID"
                    value={searchData.groupID}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value="0">--Select Group--</MenuItem>
                    {generateDropDownMenu(groups)}
                  </Select>
                  {errors["groupID"] && (
                    <FormHelperText
                      id="errbranchCode"
                      className="text text-danger"
                    >
                      {errors["groupID"]}
                    </FormHelperText>
                  )}
                </div>

                <div className="col-md pb-1">
                  <InputLabel shrink id="operationEntityID">
                    Operation Entity *
                  </InputLabel>
                  <Select
                    fullWidth
                    id="operationEntityID"
                    disabled={!permissionList.isOperationEntityFilterEnabled}
                    name="operationEntityID"
                    value={searchData.operationEntityID}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value="0">--Select Operation Entity--</MenuItem>
                    {generateDropDownMenu(operationEntity)}
                  </Select>
                  {errors["operationEntityID"] && (
                    <FormHelperText
                      id="errbranchCode"
                      className="text text-danger"
                    >
                      {errors["operationEntityID"]}
                    </FormHelperText>
                  )}
                </div>
                <div className="col-md pb-1">
                  <TextField
                    id="date"
                    label="Date *"
                    name="date"
                    type="date"
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md pb-1">
                  <input
                    type="button"
                    className="btn btn-primary"
                    value="Generate"
                    disabled={validate(schema, searchData)}
                    onClick={(e) => handleSearch(e)}
                  />
                </div>
              </div>
            </form>

            <div hidden={isViewTable}>
              <Box minWidth={1050}>
                <MaterialTable
                  title="Multiple Actions Preview"
                  columns={[
                    { title: "Collection Point", field: "collectionPointName" },
                    {
                      title: "Date",
                      field: "cardReadTime",
                      render: (rowData) => rowData.cardReadTime.split("T")[0],
                    },
                    { title: "Tag Number", field: "tagNumber" },
                  ]}
                  data={reportData}
                  options={{
                    exportButton: false,
                    showTitle: false,
                    headerStyle: {
                      textAlign: "left",
                      height: "1%",
                      fontWeight: "bold",
                    },
                    cellStyle: { textAlign: "left" },
                    columnResizable: false,
                    actionsColumnIndex: -1,
                  }}
                  actions={[
                    {
                      icon: "replay",
                      tooltip: "Retry",
                      onClick: (event, rowData) => {
                        retryOption(rowData);
                      },
                    },
                  ]}
                />
              </Box>
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
}
